import { useEffect, useRef } from 'react'

export interface IframeComponentProps {
  slug: string
  sourceUrl: string
}

export function IframeComponent({ slug, sourceUrl }: IframeComponentProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    window.addEventListener('message', (event) => {
      const messageData = event.data
      if (messageData.type === slug.toUpperCase() + '_SCREEN_RESIZE') {
        if (iframeRef.current) {
          iframeRef.current.style.height = messageData.height + 'px'
        }
      }
    })
  }, [slug])

  return (
    <iframe
      frameBorder="0"
      id="formIframe"
      ref={iframeRef}
      scrolling="no"
      src={sourceUrl}
      style={{ display: 'block', height: '100%', width: '100%' }}
    />
  )
}

export default IframeComponent
